export const getFilteredCars = (state) => state.cars.filteredCars.data;

export default getFilteredCars;
